import { render, staticRenderFns } from "./CardRenew.vue?vue&type=template&id=3657d21e&scoped=true&"
import script from "./CardRenew.vue?vue&type=script&lang=js&"
export * from "./CardRenew.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=3657d21e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3657d21e",
  null
  
)

export default component.exports